var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-light px-4 py-2 txt_ombre_333 txt_size_125",attrs:{"id":"nav_pge_about","data-toggle":"modal","data-target":"#pge_about"}},[_c('span',{staticClass:"oi oi-double-quote-serif-left mr-2"}),_vm._v("\n    "+_vm._s(_vm.$t('infos.about'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5dfe0b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/ButtonAbout.vue
// module id = 155
// module chunks = 0